import Vue from 'vue';
import Router from 'vue-router'
import {store} from '../store'

Vue.use(Router);

import Index from '@/components/pages/Index';
import Rules from '@/components/pages/Rules';
import Test from '@/components/pages/Test';
import TestInner from '@/components/pages/TestInner';
import TestResult from '@/components/pages/TestResult';
import Video from '@/components/pages/Video';
import Product from '@/components/pages/Product';

import RatingLayout from '@/components/pages/RatingLayout';
import Rating from '@/components/pages/Rating';
import RatingInner from '@/components/pages/RatingInner';

import Profile from '@/components/pages/Profile';


const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    linkExactActiveClass: 'active-link',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/rules',
            name: 'Rules',
            component: Rules
        },
        {
            path: '/test',
            name: 'Test',
            component: Test,

		},
        {
            path: '/test/start',
            name: 'TestInner',
            component: TestInner,
            beforeEnter: (to, from, next) => {
                store.dispatch('GET_QUESTIONS').then(
                    () => {
                        next();
                    },
                    (error) => {
                        if (from.name !== null) {
                            next(`/${from.name}`);
                            store.commit('SET_POPUP', {
                                name: 'Error',
                                title: 'Ошибка!',
                                text: error
                            });
                        } else {
                            next('/');
                        }
                    });
            }
        },
        {
            path: '/test/result',
            name: 'TestResult',
            component: TestResult
        },
        {
            path: '/video',
            name: 'Video',
            component: Video,
        },
        {
            path: '/product',
            name: 'Product',
            component: Product
        },
        {
            path: '/rating',
            name: 'RatingLayout',
            component: RatingLayout,
            children: [
				{
					path: '',
					name: 'Rating',
					component: Rating
				},
				{
					path: ':id',
					name: 'RatingInner',
					component: RatingInner,
					beforeEnter : (to, from, next) => {
						store.dispatch('getRating', to.params.id).then(() => {
								next();
							},
							() => {
								next('/rating');
							});
					}
				}
            ]
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
            beforeEnter: (to, from, next) => {
                if (store.getters['isGuest']) {
                    next('/');
                } else {
                    store.dispatch('getUserRating').then(
                        () => {
                            next();
                        });
                }
            }
        }
    ]
});

/*
router.beforeEach((to, from, next) => {
	console.log('beforeEach::',to);
	next()

});*/



export default router;




// WEBPACK FOOTER //
// ./src/router/index.js